// import { Heading, Text } from '@chakra-ui/react';
// import Modal from 'react-modal';
// import { Field, Form, Formik } from 'formik';
// import { fetchOrder } from 'redux/actions/orderActions';

// import {
//     Box,
//     Button,
//     Divider,
//     HStack,
//     Image,
//     Radio,
//     RadioGroup,
//     useToast,
//     VStack,
// } from '@chakra-ui/react';
// import Paystack from '@paystack/inline-js';
// import paystack from '../../../assets/paystack-logo.png';
// import startButton from '../../../assets/startbutton-logo.jpg';
// import { useDispatch } from 'react-redux';
// import { useStartButton } from 'hooks/useStartButton';
// import styled from 'styled-components';

// const MakePaymentModal = ({ isOpen, closeModal, orderDetails }) => {
//     const toast = useToast();
//     const dispatch = useDispatch();
//     const parseCurrency = (currencyData) => {
//         if (!currencyData) return { symbol: 'USD', rate: 1 };

//         if (typeof currencyData === 'object') return currencyData;

//         if (typeof currencyData === 'string') {
//             if (currencyData.startsWith('{')) {
//                 try {
//                     return JSON.parse(currencyData);
//                 } catch (e) {
//                     return { symbol: currencyData, rate: 1 };
//                 }
//             }
//             return { symbol: currencyData, rate: 1 };
//         }

//         return { symbol: 'USD', rate: 1 };
//     };

//     const parsedCurrency = parseCurrency(orderDetails?.currency);
//     const finalCurrency = parsedCurrency.symbol || 'USD';
//     // eslint-disable-next-line no-unused-vars
//     const finalRate = parsedCurrency.rate || 1;

//     const { initializePayment } = useStartButton();
//     const makePayment = async (orderId, selectedOption) => {
//         const shipment = orderDetails?.shipment_details
//             ? JSON.parse(orderDetails?.shipment_details)
//             : {};

//         if (selectedOption === 'PAYSTACK') {
//             const popup = new Paystack();
//             popup.checkout({
//                 key:
//                     process.env.REACT_APP_PAYSTACK_PUBLIC_KEY ||
//                     'pk_test_df60dcfa8294d512014a61bbf99365693b238608',
//                 email: shipment?.delivery_address?.email,
//                 amount: orderDetails?.amount * 100,
//                 currency: finalCurrency,
//                 metaData: shipment?.delivery_address,
//                 reference: orderId,
//                 onSuccess: (transaction) => {
//                     toast({
//                         title: 'Order Created Successfully',
//                         description:
//                             'Your order was created successfully. You will receive an email shortly.',
//                         status: 'success',
//                         duration: 3000,
//                         isClosable: true,
//                     });
//                     dispatch(fetchOrder());
//                     closeModal?.();
//                 },
//                 onCancel: () => {
//                     toast({
//                         title: 'Payment Cancelled',
//                         description: 'You cancelled the payment.',
//                         status: 'warning',
//                         duration: 3000,
//                         isClosable: true,
//                     });
//                     dispatch(fetchOrder());
//                     closeModal?.();
//                 },
//                 onError: (error) => {
//                     toast({
//                         title: 'Payment Error',
//                         description: error.message || 'Payment failed',
//                         status: 'error',
//                         duration: 3000,
//                         isClosable: true,
//                     });
//                     dispatch(fetchOrder());
//                     closeModal?.();
//                 },
//             });
//         } else if (selectedOption === 'STARTBUTTON') {
//             // Country/currency logic (mirror obana-shop)
//             const paymentMethodsMap = {
//                 NGN: ['bank', 'card', 'bank_transfer', 'ussd', 'payattitude'],
//                 GHS: ['card', 'mobile_money'],
//                 ZAR: ['eft', 'qr', 'card'],
//                 KES: ['card', 'mobile_money'],
//                 UGX: ['card', 'mobile_money'],
//                 RWF: ['card', 'mobile money'],
//                 XOF: ['card', 'mobile_money'],
//                 XAF: ['card', 'mobile_money'],
//             };

//             await initializePayment({
//                 phone: shipment?.delivery_address?.phone?.replace(/\D/g, ''),
//                 key:
//                     process.env.REACT_APP_STARTBUTTON_PUBLIC_KEY ||
//                     'sb_eac44b58a06889164bd4275cb92871740c1f426d14eae111d8efa3b96b9a6bbb',
//                 amount: orderDetails?.amount * 100,
//                 paymentMethods: paymentMethodsMap[finalCurrency] || ['card'],
//                 env: 'test',
//                 currency: finalCurrency,
//                 email: shipment?.delivery_address?.email,
//                 reference: orderId,
//                 metadata: shipment?.delivery_address,
//                 success: (response) => {
//                     console.log('StartButton success:', response);
//                     // The actual success handling will be done via webhook
//                     // But we'll still update the UI optimistically

//                     dispatch(fetchOrder());
//                     closeModal?.();
//                 },
//                 close: () => {
//                     console.log('StartButton payment modal closed');
//                     closeModal?.();
//                 },
//                 error: (error) => {
//                     console.error('StartButton error:', error);
//                     toast({
//                         title: 'Payment Error',
//                         description: error?.statusText || 'Payment failed',
//                         status: 'error',
//                         duration: 3000,
//                         isClosable: true,
//                     });
//                     dispatch(fetchOrder());
//                     closeModal?.();
//                 },
//                 onCancel: () => {
//                     console.log('onCancel');
//                     closeModal?.();
//                 },
//                 onLoad: (response) => {
//                     console.log('onLoad: ', response);
//                 },
//             });
//         }
//     };
//     const handleSubmit = async (values, { setSubmitting }) => {
//         setSubmitting(true);
//         try {
//             // Your form submission logic here
//             await makePayment(orderDetails.order_id, values.selectedOption);
//         } catch (error) {
//             console.error('Error submitting form:', error);
//         } finally {
//             setSubmitting(false);
//         }
//     };
//     return (
//         <Modal
//             isOpen={isOpen}
//             onRequestClose={closeModal}
//             className="Modal"
//             overlayClassName="Overlay">
//             <ModalContainer>
//                 <Heading as="h4" textAlign="center" fontSize="24px" mt="20px">
//                     Complete Payment
//                 </Heading>

//                 <Formik
//                     initialValues={{
//                         selectedOption: '',
//                     }}
//                     // validationSchema={DispatchOptionsSchema}
//                     onSubmit={handleSubmit}>
//                     {({ values, errors, touched, isSubmitting, setFieldValue }) => (
//                         <Form>
//                             <VStack spacing={4} align="stretch">
//                                 <Heading size="sm" textAlign="center">
//                                     Choose Payment Option
//                                 </Heading>

//                                 <Divider />

//                                 {/* Options Section */}
//                                 <Field name="selectedOption">
//                                     {({ field, form }) => (
//                                         <RadioGroup
//                                             {...field}
//                                             onChange={(val) => {
//                                                 form.setFieldValue('selectedOption', val);
//                                             }}>
//                                             <VStack align="stretch" spacing={3}>
//                                                 <Box
//                                                     border="1px"
//                                                     borderColor="gray.200"
//                                                     padding={3}
//                                                     borderRadius="md">
//                                                     <Radio
//                                                         value={'PAYSTACK'}
//                                                         isDisabled={finalCurrency !== 'NGN'}>
//                                                         <HStack
//                                                             justify="space-between"
//                                                             align="center"
//                                                             width="100%">
//                                                             <VStack
//                                                                 align="start"
//                                                                 spacing={0}
//                                                                 flex={1}>
//                                                                 <Text fontWeight="semibold">
//                                                                     Pay with Paystack (
//                                                                     {finalCurrency})
//                                                                 </Text>
//                                                             </VStack>
//                                                             <Image
//                                                                 src={paystack}
//                                                                 alt="Paystack"
//                                                                 height="24px"
//                                                                 width="auto"
//                                                             />
//                                                         </HStack>
//                                                     </Radio>
//                                                 </Box>

//                                                 <Box
//                                                     border="1px"
//                                                     borderColor="gray.200"
//                                                     padding={3}
//                                                     borderRadius="md">
//                                                     <Radio value={'STARTBUTTON'}>
//                                                         <HStack
//                                                             justify="space-between"
//                                                             align="center"
//                                                             width="100%">
//                                                             <VStack
//                                                                 align="start"
//                                                                 spacing={0}
//                                                                 flex={1}>
//                                                                 <Text fontWeight="semibold">
//                                                                     Pay with StartButton (
//                                                                     {finalCurrency})
//                                                                 </Text>
//                                                             </VStack>
//                                                             <Image
//                                                                 src={startButton}
//                                                                 alt="StartButton"
//                                                                 height="44px"
//                                                                 width="auto"
//                                                             />
//                                                         </HStack>
//                                                     </Radio>
//                                                 </Box>
//                                             </VStack>
//                                         </RadioGroup>
//                                     )}
//                                 </Field>

//                                 {/* Error Messages */}
//                                 {errors.selectedOption && touched.selectedOption && (
//                                     <Text color="red.500" textAlign="center">
//                                         {errors.selectedOption}
//                                     </Text>
//                                 )}

//                                 {/* Submit Button */}

//                                 <Button
//                                     type="submit"
//                                     width="100%"
//                                     background="#1b3b5f"
//                                     color="#ffffff"
//                                     fontWeight="200"
//                                     fontSize="sm"
//                                     isLoading={isSubmitting}
//                                     isDisabled={!values.selectedOption}>
//                                     Proceed
//                                 </Button>
//                             </VStack>
//                         </Form>
//                     )}
//                 </Formik>
//             </ModalContainer>
//         </Modal>
//     );
// };

// export default MakePaymentModal;
// const ModalContainer = styled.div`
//     width: 500px;
//     max-height: 70vh;
//     background: #ffffff;
//     border-radius: 16px;
//     padding: 24px;
//     overflow-y: auto;

//     @media screen and (max-width: 500px) {
//         padding: 18px;
//         width: 100vw;
//         max-height: 100%;
//         border-radius: 16px 16px 0px 0px;
//     }
// `;

import { useState } from 'react';
import {
    Box, Button, Flex, Heading, Text, Image, Divider,
    Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton,
    useToast,
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import Paystack from '@paystack/inline-js';
import { fetchOrder } from 'redux/actions/orderActions';
import { useStartButton } from 'hooks/useStartButton';
import paystack from '../../../assets/paystack-logo.png';
import startButton from '../../../assets/startbutton-logo.jpg';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS
   ───────────────────────────────────────────────────────────── */
const NAVY        = '#1B3B5F';
const NAVY_DEEP   = '#0F2940';
const CYAN        = '#DCF8F9';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';
const DANGER      = '#E53E3E';
// const SUCCESS     = '#10B981';

const FONT      = "'Bricolage Grotesque', sans-serif";
// const SHADOW_SM = '0 1px 3px rgba(27,59,95,0.06)';

/* ─────────────────────────────────────────────────────────────
   ICONS
   ───────────────────────────────────────────────────────────── */
const CheckIcon = (props) => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.6"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
const LockIcon = (props) => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" {...props}>
        <rect x="3" y="11" width="18" height="11" rx="2"
            stroke="currentColor" strokeWidth="1.8" />
        <path d="M7 11V7a5 5 0 0110 0v4"
            stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

/* ─────────────────────────────────────────────────────────────
   CURRENCY PARSING — preserved exactly from original
   ───────────────────────────────────────────────────────────── */
const parseCurrency = (currencyData) => {
    if (!currencyData) return { symbol: 'USD', rate: 1 };
    if (typeof currencyData === 'object') return currencyData;
    if (typeof currencyData === 'string') {
        if (currencyData.startsWith('{')) {
            try {
                return JSON.parse(currencyData);
            } catch (e) {
                return { symbol: currencyData, rate: 1 };
            }
        }
        return { symbol: currencyData, rate: 1 };
    }
    return { symbol: 'USD', rate: 1 };
};

/* ─────────────────────────────────────────────────────────────
   PAYMENT METHOD CARD
   ───────────────────────────────────────────────────────────── */
const PaymentMethodCard = ({
    id, name, currency, logo, logoHeight = '24px',
    isSelected, isDisabled, disabledReason, onSelect,
}) => (
    <Box
        as="button"
        type="button"
        onClick={() => !isDisabled && onSelect(id)}
        disabled={isDisabled}
        bg={SURFACE}
        border="2px solid"
        borderColor={isSelected ? NAVY : BORDER}
        borderRadius="12px"
        p="14px 16px"
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        opacity={isDisabled ? 0.55 : 1}
        textAlign="left"
        w="full"
        transition="all 0.15s ease"
        boxShadow={isSelected ? `0 0 0 3px ${CYAN}` : 'none'}
        _hover={
            isDisabled
                ? undefined
                : {
                      borderColor: isSelected ? NAVY : '#CBD5E0',
                      transform: 'translateY(-1px)',
                  }
        }
        _focusVisible={{
            outline: `2px solid ${NAVY}`,
            outlineOffset: '2px',
        }}
        aria-label={`Pay with ${name}${isDisabled ? ` (${disabledReason})` : ''}`}
        aria-pressed={isSelected}
    >
        <Flex justify="space-between" align="center" gap="12px">
            <Flex align="center" gap="12px" minW="0" flex="1">
                {/* Selection indicator */}
                <Flex
                    w="20px"
                    h="20px"
                    borderRadius="full"
                    border="2px solid"
                    borderColor={isSelected ? NAVY : BORDER}
                    bg={isSelected ? NAVY : 'transparent'}
                    color="white"
                    align="center"
                    justify="center"
                    flexShrink={0}
                    transition="all 0.15s ease"
                >
                    {isSelected && <CheckIcon />}
                </Flex>

                {/* Provider info */}
                <Box minW="0" flex="1">
                    <Text
                        fontSize="13px"
                        fontWeight="700"
                        color={INK}
                        fontFamily={FONT}
                        lineHeight="1.3"
                        noOfLines={1}
                    >
                        {name}
                    </Text>
                    {isDisabled && disabledReason ? (
                        <Text fontSize="10.5px" color={DANGER} fontWeight="600" mt="2px">
                            {disabledReason}
                        </Text>
                    ) : (
                        <Text fontSize="10.5px" color={MUTED} mt="2px">
                            Paying in {currency}
                        </Text>
                    )}
                </Box>
            </Flex>

            {/* Provider logo */}
            <Box flexShrink={0}>
                <Image
                    src={logo}
                    alt={`${name} logo`}
                    height={logoHeight}
                    width="auto"
                    objectFit="contain"
                />
            </Box>
        </Flex>
    </Box>
);

/* ─────────────────────────────────────────────────────────────
   MAIN
   ───────────────────────────────────────────────────────────── */
const MakePaymentModal = ({ isOpen, closeModal, orderDetails }) => {
    const toast    = useToast();
    const dispatch = useDispatch();
    const { initializePayment } = useStartButton();

    const [selectedOption, setSelectedOption] = useState('');
    const [isSubmitting, setIsSubmitting]     = useState(false);

    /* Currency — preserved logic */
    const parsedCurrency = parseCurrency(orderDetails?.currency);
    const finalCurrency  = parsedCurrency.symbol || 'USD';
    // eslint-disable-next-line no-unused-vars
    const finalRate      = parsedCurrency.rate || 1;

    /* Payment method maps — preserved exactly */
    const paymentMethodsMap = {
        NGN: ['bank', 'card', 'bank_transfer', 'ussd', 'payattitude'],
        GHS: ['card', 'mobile_money'],
        ZAR: ['eft', 'qr', 'card'],
        KES: ['card', 'mobile_money'],
        UGX: ['card', 'mobile_money'],
        RWF: ['card', 'mobile money'],
        XOF: ['card', 'mobile_money'],
        XAF: ['card', 'mobile_money'],
    };

    /* makePayment — preserved exactly, just adapted from Formik to local state */
    const makePayment = async (orderId, option) => {
        const shipment = orderDetails?.shipment_details
            ? JSON.parse(orderDetails?.shipment_details)
            : {};

        if (option === 'PAYSTACK') {
            const popup = new Paystack();
            popup.checkout({
                key:
                    process.env.REACT_APP_PAYSTACK_PUBLIC_KEY ||
                    'pk_test_df60dcfa8294d512014a61bbf99365693b238608',
                email: shipment?.delivery_address?.email,
                amount: orderDetails?.amount * 100,
                currency: finalCurrency,
                metaData: shipment?.delivery_address,
                reference: orderId,
                onSuccess: (transaction) => {
                    toast({
                        title: 'Order created successfully',
                        description:
                            'Your order was created successfully. You will receive an email shortly.',
                        status: 'success',
                        duration: 3000,
                        isClosable: true,
                    });
                    dispatch(fetchOrder());
                    closeModal?.();
                },
                onCancel: () => {
                    toast({
                        title: 'Payment cancelled',
                        description: 'You cancelled the payment.',
                        status: 'warning',
                        duration: 3000,
                        isClosable: true,
                    });
                    dispatch(fetchOrder());
                    closeModal?.();
                },
                onError: (error) => {
                    toast({
                        title: 'Payment error',
                        description: error.message || 'Payment failed',
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                    });
                    dispatch(fetchOrder());
                    closeModal?.();
                },
            });
        } else if (option === 'STARTBUTTON') {
            await initializePayment({
                phone: shipment?.delivery_address?.phone?.replace(/\D/g, ''),
                key:
                    process.env.REACT_APP_STARTBUTTON_PUBLIC_KEY ||
                    'sb_eac44b58a06889164bd4275cb92871740c1f426d14eae111d8efa3b96b9a6bbb',
                amount: orderDetails?.amount * 100,
                paymentMethods: paymentMethodsMap[finalCurrency] || ['card'],
                env: 'test',
                currency: finalCurrency,
                email: shipment?.delivery_address?.email,
                reference: orderId,
                metadata: shipment?.delivery_address,
                success: (response) => {
                    console.log('StartButton success:', response);
                    dispatch(fetchOrder());
                    closeModal?.();
                },
                close: () => {
                    console.log('StartButton payment modal closed');
                    closeModal?.();
                },
                error: (error) => {
                    console.error('StartButton error:', error);
                    toast({
                        title: 'Payment error',
                        description: error?.statusText || 'Payment failed',
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                    });
                    dispatch(fetchOrder());
                    closeModal?.();
                },
                onCancel: () => {
                    console.log('onCancel');
                    closeModal?.();
                },
                onLoad: (response) => {
                    console.log('onLoad: ', response);
                },
            });
        }
    };

    const handleSubmit = async (e) => {
        e?.preventDefault();
        if (!selectedOption) return;
        setIsSubmitting(true);
        try {
            await makePayment(orderDetails.order_id, selectedOption);
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={closeModal}
            isCentered
            motionPreset="slideInBottom"
            scrollBehavior="inside"
            size={{ base: 'full', sm: 'md' }}
        >
            <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(2px)" />
            <ModalContent
                bg={SURFACE}
                borderRadius={{ base: '16px 16px 0 0', sm: '16px' }}
                fontFamily={FONT}
                mx={{ base: '0', sm: '14px' }}
                mb={{ base: '0', sm: 'auto' }}
                mt={{ base: 'auto', sm: '60px' }}
                maxH={{ base: '92vh', sm: '85vh' }}
                boxShadow="0 24px 60px rgba(27,59,95,0.18)"
                overflow="hidden"
            >
                {/* HEADER */}
                <Box p="20px 24px 16px" borderBottom="1px solid" borderColor={BORDER}>
                    <Flex justify="space-between" align="flex-start" gap="14px">
                        <Box minW="0" flex="1">
                            <Heading
                                as="h2"
                                fontSize={{ base: '18px', md: '20px' }}
                                fontWeight="800"
                                color={INK}
                                fontFamily={FONT}
                                letterSpacing="-0.02em"
                                lineHeight="1.2"
                                mb="4px"
                            >
                                Complete payment
                            </Heading>
                            <Text fontSize="12px" color={MUTED}>
                                Choose how you'd like to pay
                            </Text>
                        </Box>
                        <ModalCloseButton
                            position="static"
                            color={MUTED}
                            borderRadius="8px"
                            _hover={{ bg: SURFACE_ALT, color: INK }}
                        />
                    </Flex>
                </Box>

                {/* BODY */}
                <ModalBody p="20px 24px">
                    <form onSubmit={handleSubmit}>
                        <Flex direction="column" gap="10px">
                            <Text
                                fontSize="10.5px"
                                color={FAINT}
                                fontWeight="700"
                                letterSpacing="0.08em"
                                mb="2px"
                            >
                                PAYMENT METHOD
                            </Text>

                            {/* Paystack */}
                            <PaymentMethodCard
                                id="PAYSTACK"
                                name="Paystack"
                                currency={finalCurrency}
                                logo={paystack}
                                logoHeight="24px"
                                isSelected={selectedOption === 'PAYSTACK'}
                                isDisabled={finalCurrency !== 'NGN'}
                                disabledReason={
                                    finalCurrency !== 'NGN'
                                        ? `Only available for NGN payments`
                                        : null
                                }
                                onSelect={setSelectedOption}
                            />

                            {/* StartButton */}
                            <PaymentMethodCard
                                id="STARTBUTTON"
                                name="StartButton"
                                currency={finalCurrency}
                                logo={startButton}
                                logoHeight="34px"
                                isSelected={selectedOption === 'STARTBUTTON'}
                                isDisabled={false}
                                onSelect={setSelectedOption}
                            />

                            {/* Trust signal */}
                            <Flex align="center" gap="6px" mt="6px" color={FAINT}>
                                <LockIcon />
                                <Text fontSize="10.5px" color={FAINT} lineHeight="1.4">
                                    Your payment is encrypted and secure
                                </Text>
                            </Flex>
                        </Flex>

                        <Divider my="20px" borderColor={BORDER} />

                        {/* Order summary line */}
                        {orderDetails?.amount != null && (
                            <Flex justify="space-between" align="center" mb="18px">
                                <Text fontSize="13px" color={MUTED} fontWeight="600">
                                    Total to pay
                                </Text>
                                <Text
                                    fontSize="18px"
                                    color={INK}
                                    fontWeight="800"
                                    fontFamily={FONT}
                                >
                                    {finalCurrency}{' '}
                                    {Number(orderDetails.amount).toLocaleString(
                                        undefined,
                                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                                    )}
                                </Text>
                            </Flex>
                        )}

                        {/* Submit button */}
                        <Button
                            type="submit"
                            w="full"
                            h="48px"
                            bg={NAVY}
                            color="white"
                            _hover={{ bg: NAVY_DEEP }}
                            _active={{ bg: NAVY_DEEP }}
                            _disabled={{
                                bg: BORDER,
                                color: FAINT,
                                cursor: 'not-allowed',
                                _hover: { bg: BORDER },
                            }}
                            borderRadius="10px"
                            fontWeight="700"
                            fontSize="13px"
                            fontFamily={FONT}
                            isLoading={isSubmitting}
                            loadingText="Processing"
                            isDisabled={!selectedOption || isSubmitting}
                            aria-label={
                                !selectedOption
                                    ? 'Select a payment method to continue'
                                    : 'Proceed to payment'
                            }
                        >
                            {selectedOption ? `Proceed with ${selectedOption === 'PAYSTACK' ? 'Paystack' : 'StartButton'}` : 'Proceed'}
                        </Button>

                        <Text
                            fontSize="10.5px"
                            color={FAINT}
                            textAlign="center"
                            mt="12px"
                            lineHeight="1.4"
                        >
                            By proceeding, you agree to be redirected to the payment provider.
                        </Text>
                    </form>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default MakePaymentModal;